import React from 'react';
import { Modal, ModalBody, Row, Col } from 'reactstrap';
import _ from 'lodash';
import { MdOutlineClose } from 'react-icons/md';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

const DataPopUp = props => {
    const { t } = useTranslation();
  const { isOpen, toggle } = props;

return (
    <>
      <div className="news-feed-alert-modal">
        <Row>
          <Col>
            <Modal
              className="modal-dialog modal-lg modal-dialog-centered"
              isOpen={isOpen}
              toggle={toggle}
              centered> 
              <div className="alert-heading">
                <div className="header-text">
            &nbsp;&nbsp;
            <h6 className="heading">Disclaimer</h6>
            </div>
            <span className="cursor-ponter close-drought-icon-new" onClick={toggle}>
              <MdOutlineClose size={20} />
            </span>
            </div>
              <ModalBody className="text-center delete-modal-body">
                <div
                  style={{ display: 'flex', flexDirection: 'column', fontSize:"16px",color:'#28537d'}}
                  className="cursor-ponter  text-box"
                >   
                  <p className="warning-text">{t('DISCLAIMER.TEXT')}
                  <Link style={{color:'#dc9023'}} to={{ 
                    pathname: "https://www.ifpri.org/sites/default/files/guidelines_countries-territories-maps.pdf",
                    }} target={"_blank"} rel='noopener noreferrer' > {t('DISCLAIMER.LINK')}</Link>
                 </p>
                 <p className="warning-text">{t('DISCLAIMER.DATA_SOURCE')}</p>
                </div>
		        </ModalBody>
            </Modal>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default DataPopUp;